import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class OrderSummaryButtonModel extends ButtonBase {
    label: string = 'Order Summary';
    action: string = ACTION_STATUS.orderSummary;
    matIconName: string = 'topic';
    colorClass: string = 'color-info-500';
}